import MainContent from 'features/unifiedFlow/components/MainContent'

import CenterSection from './centerSection'
import RightSection from './rightSection'

const Generate = () => {
  return (
    <MainContent className="flex-wrap pb-4" id="main-content-page">
      <CenterSection />
      <RightSection />
    </MainContent>
  )
}

export default Generate
